import { TemplateQuestionsApi } from "@stormwater-software/lib-inspection-templates";
import xhrService from "../api";
import { getOfflineTemplateQuestionConfig } from "../../db/db";
import { withOfflineFallback } from "../offlineFallback";

export const templateQuestionConfigApi: TemplateQuestionsApi = {
  index: (templateId: number) =>
    withOfflineFallback(
      () =>
        xhrService
          .get(`/api/inspection-templates/${templateId}/questions/config`)
          .then(res => res.data)
          .catch(error => {
            // `response` is absent on network-level failures; destructuring it
            // here replaced the real error with a TypeError.
            throw new Error(error?.response?.data?.message || error.message);
          }),
      () => getOfflineTemplateQuestionConfig(templateId),
    ),
};
